import styled from 'styled-components';

export const Title = styled.div<{ logoPath: string}>`
  margin: 15px 0px 0px 5px;
  width: calc(100% - 10px);
  padding-top: 27.7%;
  background-image: url(${({logoPath}) => logoPath});
  background-size: contain;
  background-repeat: no-repeat;
`;